import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=3344e648&scoped=true"
import script from "./Support.vue?vue&type=script&lang=ts"
export * from "./Support.vue?vue&type=script&lang=ts"
import style0 from "./Support.vue?vue&type=style&index=0&id=3344e648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3344e648",
  null
  
)

export default component.exports